<script setup lang="ts">
import { IconCross, IconEdit } from '#shared'
import { computed, toRef } from 'vue'
import { useCancelMessageEdit } from '#features/message-editing'
import { useMessagePreview, type Message } from '#entities/message'

const { editingMessage } = defineProps<{ editingMessage: Message }>()

const chatId = computed(() => editingMessage.chatId)

const editingMessagePreview = useMessagePreview(toRef(() => editingMessage))
const cancelMessageEdit = useCancelMessageEdit(chatId)
</script>

<template>
  <div :class="$style.root">
    <div :class="$style.iconWrap">
      <IconEdit :class="$style.icon" />
    </div>

    <div :class="$style.body">
      <div :class="$style.label">Edit message</div>
      <div :class="$style.content">{{ editingMessagePreview }}</div>
    </div>

    <button :class="$style.cancel" @click="cancelMessageEdit">
      <IconCross />
    </button>
  </div>
</template>

<style lang="scss" module>
@use '#mixins/button' as button;

.root {
  margin-bottom: 10px;
  display: flex;
}

.iconWrap {
  margin-right: 15px;
}

.icon {
  width: 20px;
  height: 20px;
  color: var(--sc-primary);
}

.content {
  font-size: 14px;
  opacity: 0.6;
}

.cancel {
  @include button.reset;

  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.1s;
  margin-left: auto;

  &:hover {
    color: var(--sc-error);
  }
}
</style>
